enum TransactionsType {
  AUTHORIZATION = "AUTHORIZATION",
  CAPTURE = "CAPTURE",
  INBOUND_PAYMENT = "INBOUND_PAYMENT",
  INBOUND_REWARDS = "INBOUND_REWARDS",
  INBOUND_TRANSFER = "INBOUND_TRANSFER",
  INBOUND_WIRE = "INBOUND_WIRE",
  OUTBOUND_PAYMENT = "OUTBOUND_PAYMENT",
  OUTBOUND_REWARDS = "OUTBOUND_REWARDS",
  OUTBOUND_TRANSFER = "OUTBOUND_TRANSFER",
  OUTBOUND_WIRE = "OUTBOUND_WIRE",
  REFUND = "REFUND",
  CASH = "CASH",
  MILEAGE = "MILEAGE",
  INBOUND_FUNDS = "INBOUND_FUNDS",
  REFUND_PAYMENT = "REFUND_PAYMENT",
  FEE = "FEE",
  REWARDS_ACCRUAL = "REWARDS_ACCRUAL",
  BALANCE_TRANSFER = "BALANCE_TRANSFER",
  REWARDS_TO_BANK = "REWARDS_TO_BANK",
  REWARDS_TO_BALANCE = "REWARDS_TO_BALANCE",
  CHARGE_REPAYMENT = "CHARGE_REPAYMENT",
  DISPUTE_CREDIT = "DISPUTE_CREDIT",
  DISPUTE_CREDIT_REVERSAL = "DISPUTE_CREDIT_REVERSAL",
}

export default TransactionsType;
